// import mock from 'src/utils/mock';

import * as test from './payload/test';
import * as subjects from './payload/subjects.payload.json';

function subjectMockInit(mock) {
  mock.onGet('/subjects/subject/all').reply(200, getAllSubjectsAdmin());
  // mock.onGet('/users/user/role/:role').reply(200, getAllSubjects() );
  mock.onGet('/subjects/subjects').reply(200, getAllSubjects());
}

function getAllSubjectsAdmin() {
  return test;
}

function getAllSubjects() {
  return subjects.default;
}

export { subjectMockInit };
